var _rect, _path, _g, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
const SvgSend = props => /*#__PURE__*/React.createElement("svg", _extends({
  xmlns: "http://www.w3.org/2000/svg",
  width: 49,
  height: 48,
  fill: "none"
}, props), _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
  width: 40,
  height: 40,
  x: 4.5,
  y: 4,
  fill: "url(#send_svg__a)",
  rx: 8
})), /*#__PURE__*/React.createElement("mask", {
  id: "send_svg__b",
  width: 25,
  height: 24,
  x: 12,
  y: 12,
  maskUnits: "userSpaceOnUse",
  style: {
    maskType: "alpha"
  }
}, _path || (_path = /*#__PURE__*/React.createElement("path", {
  fill: "#D9D9D9",
  d: "M12.5 12h24v24h-24z"
}))), _g || (_g = /*#__PURE__*/React.createElement("g", {
  mask: "url(#send_svg__b)"
}, /*#__PURE__*/React.createElement("path", {
  fill: "#fff",
  d: "M16.9 31.424a.99.99 0 0 1-.95-.087q-.45-.288-.45-.838V26l8-2-8-2v-4.5q0-.55.45-.837a.99.99 0 0 1 .95-.088l15.4 6.5q.625.276.625.925 0 .65-.625.925z"
}))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
  id: "send_svg__a",
  x1: 4.5,
  x2: 44.5,
  y1: 24,
  y2: 24,
  gradientUnits: "userSpaceOnUse"
}, /*#__PURE__*/React.createElement("stop", {
  stopColor: "#006A59"
}), /*#__PURE__*/React.createElement("stop", {
  offset: 1,
  stopColor: "#00FF59"
})))));
export { SvgSend as ReactComponent };
export default "data:image/svg+xml;base64,PHN2ZyB3aWR0aD0iNDkiIGhlaWdodD0iNDgiIHZpZXdCb3g9IjAgMCA0OSA0OCIgZmlsbD0ibm9uZSIgeG1sbnM9Imh0dHA6Ly93d3cudzMub3JnLzIwMDAvc3ZnIj4KPHJlY3QgeD0iNC41IiB5PSI0IiB3aWR0aD0iNDAiIGhlaWdodD0iNDAiIHJ4PSI4IiBmaWxsPSJ1cmwoI3BhaW50MF9saW5lYXJfNjkxMzJfMzQyMDkxKSIvPgo8bWFzayBpZD0ibWFzazBfNjkxMzJfMzQyMDkxIiBzdHlsZT0ibWFzay10eXBlOmFscGhhIiBtYXNrVW5pdHM9InVzZXJTcGFjZU9uVXNlIiB4PSIxMiIgeT0iMTIiIHdpZHRoPSIyNSIgaGVpZ2h0PSIyNCI+CjxyZWN0IHg9IjEyLjUiIHk9IjEyIiB3aWR0aD0iMjQiIGhlaWdodD0iMjQiIGZpbGw9IiNEOUQ5RDkiLz4KPC9tYXNrPgo8ZyBtYXNrPSJ1cmwoI21hc2swXzY5MTMyXzM0MjA5MSkiPgo8cGF0aCBkPSJNMTYuOSAzMS40MjQyQzE2LjU2NjcgMzEuNTU3NiAxNi4yNSAzMS41Mjg0IDE1Ljk1IDMxLjMzNjdDMTUuNjUgMzEuMTQ1MSAxNS41IDMwLjg2NTkgMTUuNSAzMC40OTkyVjI1Ljk5OTJMMjMuNSAyMy45OTkyTDE1LjUgMjEuOTk5MlYxNy40OTkyQzE1LjUgMTcuMTMyNiAxNS42NSAxNi44NTM0IDE1Ljk1IDE2LjY2MTdDMTYuMjUgMTYuNDcwMSAxNi41NjY3IDE2LjQ0MDkgMTYuOSAxNi41NzQyTDMyLjMgMjMuMDc0MkMzMi43MTY3IDIzLjI1NzYgMzIuOTI1IDIzLjU2NTkgMzIuOTI1IDIzLjk5OTJDMzIuOTI1IDI0LjQzMjYgMzIuNzE2NyAyNC43NDA5IDMyLjMgMjQuOTI0MkwxNi45IDMxLjQyNDJaIiBmaWxsPSJ3aGl0ZSIvPgo8L2c+CjxkZWZzPgo8bGluZWFyR3JhZGllbnQgaWQ9InBhaW50MF9saW5lYXJfNjkxMzJfMzQyMDkxIiB4MT0iNC41IiB5MT0iMjQiIHgyPSI0NC41IiB5Mj0iMjQiIGdyYWRpZW50VW5pdHM9InVzZXJTcGFjZU9uVXNlIj4KPHN0b3Agc3RvcC1jb2xvcj0iIzAwNkE1OSIvPgo8c3RvcCBvZmZzZXQ9IjEiIHN0b3AtY29sb3I9IiMwMEZGNTkiLz4KPC9saW5lYXJHcmFkaWVudD4KPC9kZWZzPgo8L3N2Zz4K";